import {BibAutorModel} from '@/models/biblioteca/bibautor/bibautor.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class BibAutorService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<BibAutorModel>>> {
  return api.post <DataSource <BibAutorModel>>('/BibAutor/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(bibAutor: BibAutorModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibAutor', bibAutor);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibAutor/' + id);
 }

 atualizar(bibAutor: BibAutorModel): Promise<AxiosResponse> {
  return api.put('/BibAutor', bibAutor);
 }

 async get(id: number): Promise<BibAutorModel> {
  const result = await api.get<BibAutorModel>(`/BibAutor/${id.toString()}`);
  return result.data;
 }
 async DropDownList(): Promise<TextoValor[]> {
    const endpoint = "/BibAutor/DropDownList";
    const result = await api.get(endpoint);
    console.log(result);

    // Mapeando os dados para o formato TextoValor
    return result.data.map((item: any) => ({
      valor: item.valor,
      texto: item.texto,
    }));
  }
  
}
export default new BibAutorService();
